import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { FETCH_INCIDENTS_COUNT_ASYNC } from './constants'

const initialState = {
  data: {},
  loader: false,
  error: null,
}

export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case FETCH_INCIDENTS_COUNT_ASYNC.INITIATE:
        return {
          ...state,
          loader: !!action.payload?.params?.coldStart,
          error: null,
        }
      case FETCH_INCIDENTS_COUNT_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case FETCH_INCIDENTS_COUNT_ASYNC.ERROR:
        return { ...state, error: action.error }
      case FETCH_INCIDENTS_COUNT_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
